import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`, // Uses environment variable
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    console.log(`API Request: ${config.method.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response.data;
  },
  (error) => {
    console.error('API Error:', {
      message: error.message,
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data
    });
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    if (error.message === 'Network Error') {
      console.error('Network Error - Check if backend is running');
      alert(`Cannot connect to server. Make sure backend is running on ${process.env.REACT_APP_API_URL}`);
    }
    
    return Promise.reject(error);
  }
);

export const createCollege = async (collegeData) => {
  const response = await api.post('/colleges', collegeData);
  return response;
};

export const getColleges = async () => {
  const response = await api.get('/colleges');
  return response;
};

export const getCollegeById = async (id) => {
  const response = await api.get(`/colleges/${id}`);
  return response;
};

export const getCollegeDetails = async (id) => {
  const response = await api.get(`/colleges/${id}/details`);
  return response;
};

export const addTeacherToCollege = async (id, teacherData) => {
  const response = await api.post(`/colleges/${id}/teachers`, teacherData);
  return response;
};

export const deleteCollege = async (id) => {
  const response = await api.delete(`/colleges/${id}`);
  return response;
};

export const getUsers = async (params = {}) => {
  const response = await api.get('/admin/users', { params });
  return response;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/admin/users/${id}`);
  return response;
};

export const getAdminStats = async () => {
  const response = await api.get('/admin/stats');
  return response;
};

export default api;